module.exports = __webpack_public_path__ + "static/media/main-md.d7edd828.svg";